import { type InitFlowComponent } from '@capsicum/common';

import { useV2FTMigrationInitFlow } from '../../hooks/useV2FTMigrationInitFlow';
import { V2FTMigrationFAQScreen } from '../../ui/v2ft-migration/V2FTMigrationFAQScreen';
import { V2FTMigrationUpgradeModalScreen } from '../../ui/v2ft-migration/V2FTMigrationUpgradeModalScreen';
import { V2FTMigrationUpgradeScreen } from '../../ui/v2ft-migration/V2FTMigrationUpgradeScreen';

export const V2FTMigrationInitFlow: InitFlowComponent = ({ fallback, isReactive, next }) =>
	useV2FTMigrationInitFlow({
		fallback,
		isReactive,
		next,
		screens: {
			FAQ: V2FTMigrationFAQScreen,
			MODAL: V2FTMigrationUpgradeModalScreen,
			UPGRADE: V2FTMigrationUpgradeScreen
		}
	});

V2FTMigrationInitFlow.keepAlive = true;
